import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { setPageTitle }    from "../../../utils/document";
import DashboardLayout     from "../../../components/layout/DashboardLayout";
import AssociateMaster from "../PMO/components/AssociateMaster";
import SCGPool from "../PMO//components/SCGPool";
import Approvals from "../PMO/components/Approvals";
import PositionIDManagement from "../PMO/components/PositionIDManagement";
import Reports from "../PMO/components/Reports";



const SCG_TABS = [
  { id: "approvals",              label: "Approvals"        },
  { id: "associate-master",       label: "Associate Master" },
  { id: "scg-pools",              label: "SCG Pool"         },
  { id: "positions",              label: "Positions"        },
  { id: "reports", label: "Reports" },
];

const SCGDashboard = () => {
  const [searchParams] = useSearchParams();
  const tabParam    = searchParams.get("tab");
  const codeParam   = searchParams.get("requestCode");
  const filterParam = searchParams.get("filter");

  const [activeTab, setActiveTab] = useState(
    tabParam && SCG_TABS.some((t) => t.id === tabParam) ? tabParam : "approvals"
  );
  const [approvalCount,  setApprovalCount]  = useState(null);
  const [initialRequestCode, setInitialRequestCode] = useState(codeParam ?? null);

  useEffect(() => { setPageTitle("SCG Dashboard"); }, []);

  return (
    <DashboardLayout
      tabs={SCG_TABS}
      activeTab={activeTab}
      onTabChange={setActiveTab}
    >
      {activeTab === "approvals" && (
        <Approvals
          onSummaryLoad={setApprovalCount}
          initialRequestCode={initialRequestCode}
          onInitialRequestHandled={() => setInitialRequestCode(null)}
          defaultFilter="at_scg"
        />
      )}
      {activeTab === "associate-master" && <AssociateMaster initialFilter={filterParam ?? "billable"} />}
      {activeTab === "scg-pools" && <SCGPool />}
      {activeTab === "positions" && (  // ADD THIS BLOCK
        <PositionIDManagement readOnly={true} />
      )}
      {activeTab === "reports" && <Reports />}
    </DashboardLayout>
  );
};

export default SCGDashboard;